module.exports = __webpack_public_path__ + "static/img/1-1.491a9f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/1-1.png
// module id = 4NrZ
// module chunks = 0